// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1oTN_","clinicsSelect":"TableHeading_clinicsSelect__3_eXS"};